/** Session flag: user must stay on account-banned until they log out. */
export const ACCOUNT_BANNED_SESSION_KEY = "tv_account_banned";

export function markAccountBannedSession(): void {
  try {
    sessionStorage.setItem(ACCOUNT_BANNED_SESSION_KEY, "1");
  } catch {
    // ignore
  }
}

export function clearAccountBannedSession(): void {
  try {
    sessionStorage.removeItem(ACCOUNT_BANNED_SESSION_KEY);
  } catch {
    // ignore
  }
}

export function isAccountBannedSession(): boolean {
  try {
    return sessionStorage.getItem(ACCOUNT_BANNED_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}
